import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import preval from "preval.macro";
import { useAuth0 } from "@auth0/auth0-react";
import { Nav } from "react-bootstrap";

import { kombusLinksArray } from "../../data/constants";
import { configAgencyName } from "../../config";

const FooterContainer = styled.div<{}>`
  position: relative;
  width: 100%;
  height: 73px;
  div.kombus-links {
    position: absolute;
    bottom: 0.5rem;
    right: 0.5rem;
    ul {
      margin-bottom: 0 !important;
      font-size: 0.8rem;
      list-style-type: none;
    }
  }
`;

const Footer = (): JSX.Element => {
  const { t } = useTranslation();

  const { isAuthenticated } = useAuth0();

  const kombusAgenciesNames: string[] = kombusLinksArray.map((agency) => agency?.configAgencyName);

  const KombusLinks = ({ linksArray }: { linksArray: ObjectI[] }): JSX.Element => {
    return (
      <ul>
        {linksArray.map(
          (link: ObjectI, index: number): JSX.Element => (
            <li key={`${index}_${link.url as string}`}>
              <Nav.Link
                href={link.url as string}
                target="_blank"
                rel="noreferrer"
                disabled={link.configAgencyName === configAgencyName ? true : false}
                className={link.configAgencyName === configAgencyName ? "text-dark" : "bg-secondary text-white"}
                style={{ fontWeight: link.configAgencyName === configAgencyName ? "normal" : "bold" }}
              >
                {link.name}
              </Nav.Link>
            </li>
          )
        )}
      </ul>
    );
  };

  //* Date of build
  const dateCurrentTimeStamp: string = preval`module.exports = new Intl.DateTimeFormat("pl-PL", { dateStyle: "short", timeStyle: "long", timeZone: "Europe/Warsaw" }).format(new Date())`;

  return (
    <React.Fragment>
      <FooterContainer>
        <footer className="d-flex flex-wrap justify-content-center bg-secondary text-white pt-3 pb-2 fixed-bottom">
          <div>
            &copy; {new Date().getFullYear()} Copyright:{" "}
            <a className="text-dark" href="https://goeuropa.eu" target="_blank" rel="noreferrer">
              <span className="span_bold">goEuropa</span>
            </a>
            <div style={{ fontSize: "smaller", paddingTop: "5px" }}>
              {t("Ostatnia aktualizacja")} <span className="span_bold">{dateCurrentTimeStamp}</span>
            </div>
          </div>

          {/* //* Kombus Links */}
          {isAuthenticated && kombusAgenciesNames.includes(configAgencyName) ? (
            <div className="kombus-links">
              <KombusLinks linksArray={kombusLinksArray} />
            </div>
          ) : null}
        </footer>
      </FooterContainer>
    </React.Fragment>
  );
};

export default Footer;
